import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be0f6e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "flex align-items-center gap-2" }
const _hoisted_3 = { class: "my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ml-1 font-bold",
  for: "coefficients-year"
}, "Year", -1))
const _hoisted_5 = { class: "flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "flex flex-column gap-1" }
const _hoisted_7 = {
  key: 1,
  class: "text-sm text-color-secondary"
}
const _hoisted_8 = { class: "flex flex-column gap-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-color-secondary m-0" }, " Fits a 2nd-order polynomial (A·GPOA² + B·GPOA + C) over valid hourly data from the prior 12 finalized billing periods, applying the Schedule 17 §3.13.2 filters (GPOA ≥ 100 W/m², positive total, MDL cap, valid quality). The result is saved as a proposal for SPPC approval — it does not change active coefficients until approved. ", -1))
const _hoisted_10 = { class: "flex flex-column gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "gen-period"
}, "Target billing period", -1))
const _hoisted_12 = {
  key: 0,
  class: "generate-result"
}
const _hoisted_13 = { class: "text-sm font-semibold mb-2" }
const _hoisted_14 = { class: "flex gap-4 flex-wrap" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-secondary text-sm" }, "Ai", -1))
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-secondary text-sm" }, "Bi", -1))
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-secondary text-sm" }, "Ci", -1))
const _hoisted_20 = { class: "font-semibold" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color-secondary text-sm" }, "Data points", -1))
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { class: "flex align-items-center justify-content-end gap-3" }
const _hoisted_24 = { class: "flex flex-column gap-4" }
const _hoisted_25 = { class: "flex flex-column gap-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "year"
}, "Year", -1))
const _hoisted_27 = { class: "flex flex-column gap-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "month"
}, "Month", -1))
const _hoisted_29 = { class: "flex flex-column gap-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "ai"
}, "Ai", -1))
const _hoisted_31 = { class: "flex flex-column gap-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "bi"
}, "Bi", -1))
const _hoisted_33 = { class: "flex flex-column gap-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-primary-50",
  for: "ci"
}, "Ci", -1))
const _hoisted_35 = { class: "flex align-items-center justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PDropdown = _resolveComponent("PDropdown")!
  const _component_PFloatLabel = _resolveComponent("PFloatLabel")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PTag = _resolveComponent("PTag")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PInputNumber = _resolveComponent("PInputNumber")!
  const _component_PConfirmDialog = _resolveComponent("PConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PCard, null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_WTitle, { text: "Coefficients" }),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createVNode(_component_PButton, {
              disabled: _ctx.yearList.length === 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportCoefficientsCsv())),
              icon: "pi pi-download",
              outlined: "",
              rounded: "",
              severity: "secondary",
              size: "small"
            }, null, 8, ["disabled"]), [
              [
                _directive_tooltip,
                `Export ${_ctx.year} coefficients to CSV`,
                void 0,
                { bottom: true }
              ]
            ]),
            (_ctx.canGenerate)
              ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openGenerateDialog())),
                  icon: "pi pi-cog",
                  label: "Generate",
                  rounded: "",
                  severity: "help",
                  size: "small"
                }, null, 512)), [
                  [
                    _directive_tooltip,
                    `Propose coefficients by regression over the prior 12 periods`,
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_PButton, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddNewOrEdit = true)),
              icon: "pi pi-plus",
              rounded: "",
              size: "small"
            }, null, 512), [
              [
                _directive_tooltip,
                `Add a new coefficient`,
                void 0,
                { left: true }
              ]
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_PFloatLabel, null, {
            default: _withCtx(() => [
              _createVNode(_component_PDropdown, {
                options: _ctx.years,
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterListByYear())),
                class: "mx-3",
                id: "coefficients-year",
                modelValue: _ctx.year,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.year) = $event))
              }, null, 8, ["options", "modelValue"]),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_PDataTable, {
          alwaysShowPaginator: false,
          highlightOnSelect: true,
          loading: _ctx.loading,
          resizableColumns: true,
          rowHover: true,
          rows: 100,
          showGridlines: true,
          sortOrder: 1,
          stripedRows: true,
          value: _ctx.yearList,
          "data-key": "id",
          paginator: "",
          size: "small",
          sortField: "month_as_num"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No records found.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PColumn, {
              bodyClass: "text-center",
              class: "justify-content-center",
              field: "month_as_num",
              headerClass: "py-3",
              style: {"width":"50px"}
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left",
              class: "justify-content-center",
              field: "month",
              header: "Month",
              headerClass: "py-3",
              style: {"width":"120px"}
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left text-wrap",
              field: "ai",
              header: "Ai",
              headerClass: "py-3"
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left text-wrap",
              field: "bi",
              header: "Bi",
              headerClass: "py-3"
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-left text-wrap",
              field: "ci",
              header: "Ci",
              headerClass: "py-3"
            }),
            _createVNode(_component_PColumn, {
              bodyClass: "text-right",
              headerClass: "py-3",
              style: {"width":"100px"}
            }, {
              body: _withCtx(({ data }) => [
                _withDirectives(_createVNode(_component_PButton, {
                  onClick: ($event: any) => (_ctx.doEdit(data)),
                  class: "p-button-xs",
                  icon: "pi pi-pencil",
                  rounded: "",
                  severity: "success",
                  text: ""
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `Edit`,
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_PButton, {
                  onClick: ($event: any) => (_ctx.doDelete($event, data.id)),
                  icon: "pi pi-trash",
                  rounded: "",
                  severity: "danger",
                  size: "small",
                  text: ""
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `Delete`,
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value"])
      ]),
      _: 1
    }),
    (_ctx.canGenerate || _ctx.proposals.length)
      ? (_openBlock(), _createBlock(_component_PCard, {
          key: 0,
          class: "mt-4"
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_WTitle, { text: "Coefficient proposals" }),
                _createVNode(_component_WSubTitle, { text: "Plant-derived (regression) coefficients pending SPPC approval — Schedule 17 §3.13.2" })
              ]),
              _withDirectives(_createVNode(_component_PButton, {
                disabled: _ctx.proposals.length === 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportProposalsCsv())),
                icon: "pi pi-download",
                label: "Export",
                outlined: "",
                rounded: "",
                severity: "secondary",
                size: "small"
              }, null, 8, ["disabled"]), [
                [
                  _directive_tooltip,
                  `Export proposals to CSV for SPPC submission`,
                  void 0,
                  { left: true }
                ]
              ])
            ])
          ]),
          content: _withCtx(() => [
            _createVNode(_component_PDataTable, {
              alwaysShowPaginator: false,
              loading: _ctx.proposalsLoading,
              rowHover: true,
              rows: 20,
              showGridlines: true,
              stripedRows: true,
              value: _ctx.proposals,
              "data-key": "id",
              paginator: "",
              size: "small"
            }, {
              empty: _withCtx(() => [
                _createTextVNode("No proposals yet. Use Generate to propose coefficients.")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_PColumn, {
                  field: "target_period",
                  header: "Target period",
                  headerClass: "py-3",
                  sortable: ""
                }),
                _createVNode(_component_PColumn, {
                  field: "month",
                  header: "Month",
                  headerClass: "py-3"
                }),
                _createVNode(_component_PColumn, {
                  field: "ai",
                  header: "Ai",
                  headerClass: "py-3"
                }),
                _createVNode(_component_PColumn, {
                  field: "bi",
                  header: "Bi",
                  headerClass: "py-3"
                }),
                _createVNode(_component_PColumn, {
                  field: "ci",
                  header: "Ci",
                  headerClass: "py-3"
                }),
                _createVNode(_component_PColumn, {
                  field: "data_points",
                  header: "Data pts",
                  headerClass: "py-3",
                  sortable: ""
                }),
                _createVNode(_component_PColumn, {
                  field: "status",
                  header: "Status",
                  headerClass: "py-3"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_PTag, {
                      severity: _ctx.proposalSeverity(data.status)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.status), 1)
                      ]),
                      _: 2
                    }, 1032, ["severity"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_PColumn, {
                  field: "generated_by",
                  header: "Generated by",
                  headerClass: "py-3"
                }),
                _createVNode(_component_PColumn, {
                  bodyClass: "text-right",
                  headerClass: "py-3",
                  style: {"width":"120px"}
                }, {
                  body: _withCtx(({ data }) => [
                    (_ctx.canGenerate && data.status === 'proposed')
                      ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                          key: 0,
                          loading: _ctx.approvingId === data.id,
                          onClick: ($event: any) => (_ctx.doApproveProposal(data)),
                          icon: "pi pi-check",
                          label: "Approve",
                          severity: "success",
                          size: "small",
                          text: ""
                        }, null, 8, ["loading", "onClick"])), [
                          [
                            _directive_tooltip,
                            `Approve and promote to active coefficients`,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      : (data.status === 'approved')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.approved_by || '—'), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PDialog, {
      style: { width: '32rem' },
      header: "Generate coefficients",
      onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelGenerate())),
      modal: "",
      visible: _ctx.showGenerate,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showGenerate) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_PDropdown, {
              options: _ctx.periodOptions,
              id: "gen-period",
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select billing period",
              modelValue: _ctx.generatePeriodId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.generatePeriodId) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          (_ctx.generateResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, " Proposed for " + _toDisplayString(_ctx.generateResult.target_period) + " (" + _toDisplayString(_ctx.generateResult.month) + ") ", 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.generateResult.ai), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.generateResult.bi), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.generateResult.ci), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.generateResult.data_points), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_PButton, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelGenerate())),
              label: "Close",
              outlined: "",
              severity: "secondary",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              disabled: !_ctx.generatePeriodId,
              loading: _ctx.generating,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doGenerate())),
              label: "Generate",
              size: "small"
            }, null, 8, ["disabled", "loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PDialog, {
      header: `${_ctx.editing? 'Edit' : 'Add a new'}`,
      onHide: _cache[18] || (_cache[18] = ($event: any) => (_ctx.cancelAddOrEdit())),
      modal: "",
      visible: _ctx.showAddNewOrEdit,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showAddNewOrEdit) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_PInputText, {
              autocomplete: "off",
              id: "year",
              size: "small",
              modelValue: _ctx.item.year,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.year) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_PInputText, {
              autocomplete: "off",
              id: "month",
              size: "small",
              modelValue: _ctx.item.month,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.month) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_PInputNumber, {
              useGrouping: false,
              autocomplete: "off",
              id: "ai",
              maxFractionDigits: "50",
              minFractionDigits: "0",
              mode: "decimal",
              size: "small",
              modelValue: _ctx.item.ai,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.ai) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_PInputNumber, {
              useGrouping: false,
              autocomplete: "off",
              id: "bi",
              maxFractionDigits: "50",
              minFractionDigits: "0",
              mode: "decimal",
              size: "small",
              modelValue: _ctx.item.bi,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.bi) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_PInputNumber, {
              useGrouping: false,
              autocomplete: "off",
              id: "ci",
              maxFractionDigits: "50",
              minFractionDigits: "0",
              mode: "decimal",
              size: "small",
              modelValue: _ctx.item.ci,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item.ci) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_PButton, {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cancelAddOrEdit())),
              label: "Cancel",
              outlined: "",
              severity: "secondary",
              size: "small"
            }),
            _createVNode(_component_PButton, {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editing? _ctx.saveUpdates() : _ctx.doAdd())),
              label: "Save",
              size: "small"
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_PConfirmDialog)
  ], 64))
}